/*
 * Copyright (c) 2026. Pacesetter
 * All Rights Reserved
 */

export const FETCH_ACCOUNTING_REPORTS_REQUEST = 'FETCH_ACCOUNTING_REPORTS_REQUEST';
export const FETCH_ACCOUNTING_REPORTS_SUCCESS = 'FETCH_ACCOUNTING_REPORTS_SUCCESS';
export const FETCH_ACCOUNTING_REPORTS_FAILURE = 'FETCH_ACCOUNTING_REPORTS_FAILURE';

export const DOWNLOAD_ACCOUNTING_REPORT_REQUEST = 'DOWNLOAD_ACCOUNTING_REPORT_REQUEST';
export const DOWNLOAD_ACCOUNTING_REPORT_SUCCESS = 'DOWNLOAD_ACCOUNTING_REPORT_SUCCESS';
export const DOWNLOAD_ACCOUNTING_REPORT_FAILURE = 'DOWNLOAD_ACCOUNTING_REPORT_FAILURE';

export const MANUAL_TRIGGER_ACCOUNTING_REQUEST = 'MANUAL_TRIGGER_ACCOUNTING_REQUEST';
export const MANUAL_TRIGGER_ACCOUNTING_SUCCESS = 'MANUAL_TRIGGER_ACCOUNTING_SUCCESS';
export const MANUAL_TRIGGER_ACCOUNTING_FAILURE = 'MANUAL_TRIGGER_ACCOUNTING_FAILURE';
export const MANUAL_TRIGGER_ACCOUNTING_CLEAR = 'MANUAL_TRIGGER_ACCOUNTING_CLEAR';

export const FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST =
  'FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST';
export const FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_SUCCESS =
  'FETCH_FAIL_REPORT_SENT_CONFIGURATION_SUCCESS';
export const FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_FAILURE =
  'FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_FAILURE';

export const UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST =
  'UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST';
export const UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_SUCCESS =
  'UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_SUCCESS';
export const UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_FAILURE =
  'UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_FAILURE';
